import { render, staticRenderFns } from "./supplier-commitment-form-wrapper.vue?vue&type=template&id=dd4ce85c&scoped=true"
import script from "./supplier-commitment-form-wrapper.vue?vue&type=script&lang=js"
export * from "./supplier-commitment-form-wrapper.vue?vue&type=script&lang=js"
import style0 from "./supplier-commitment-form-wrapper.vue?vue&type=style&index=0&id=dd4ce85c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4ce85c",
  null
  
)

export default component.exports